<script>
    import { createEventDispatcher } from 'svelte';
    let loading = false;
    let error = "";
    
	const dispatch = createEventDispatcher();

	function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
    }

    function sendMessage(message) {
		dispatch('message', message);
    }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div class="modal-container">
        <div class="modal-header">
            <button class="btn btn-clear float-right" on:click={close} aria-label="Close"></button>
            <div>Access Denied</div>
        </div>
        <div class="modal-footer">
            <div class="tile tile-centered text-left">
                <div class="tile-content">
                    <div class="tile-title error">{error}</div>
                </div>
                <div class="tile-action">
                    <button class="btn btn-primary" on:click={(e) => {
                        e.currentTarget.blur();
                        sendMessage({
                            type: "session",
                            data: {
                                workspaces: ""
                            }
                        })
                	}}>Sign out</button>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .error {
        color: red;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>